import React from 'react';
import PropTypes from 'prop-types';

const DEN = props => {

  return (
    <svg
      width={40}
      height={40}
      preserveAspectRatio="xMidYMid slice"
      clipRule="evenodd"
      fillRule="evenodd"
      viewBox="0 0 560 400"
      xmlns="http://www.w3.org/2000/svg"
      id="Broncos"
    >
      <path
        d="m108.225 153.872s-1.803 33.656 37.487 55.053c0 0 15.819 8.43 53.049 15.278 32.702 6.022 50.264 18.751 57.233 26.75 8.911 10.225 17.652 28.759 21.584 45.009 0 0 0 4.221 3.029 4.031 0 0 2.652.189 2.462-3.598 0 0-.948-25.559 6.435-37.864 5.654-10.107 15.792-18.846 32.566-24.994 0 0 11.172 8.522 27.075 8.522 11.547 0 21.773-4.925 21.773-4.925s20.257 7.006 22.532 17.984c0 0 .19 2.654-.568 4.546l25.369 1.327 13.822-12.497s-25.748-1.894-26.316-9.279c0 0-.4-3.426 6.55-3.426 0 0 16.02-.266 30.937 22.042l8.543-22.441s-6.552-3.275-6.419-9.292c0 0-.133-3.674 2.745-11.023l-10.622-4.825s-5.755-5.399-40.233-26.908l4.469-2.875-38.15-16.512s-12.217-19.252-46.293-19.386c0 0-26.601-43.639-69.049-43.639 0 0-15.666-.93-33.591 8.498 0 0-7.173 3.275-14.12 7.216 0 0-14.562 10.089-31.203-11.908 0 0-6.063 25.979 12.172 37.092 0 0-17.438 3.672-23.59-11.285 0 0-5.622-11.42-4.071-30.542 0 0-13.366 12.084-13.366 35.275 0 0-.133 14.783 9.691 24.875 0 0-4.956-.754-12.835 4.205-.005-.003-13.768 9.957-29.097-10.484z"
        fill="#024"
      />
      <path
        d="m173.249 116.247s2.56 22.913 22.064 22.913c0 0 7.665 0 14.668-2.654 7.006-2.654 17.23-7.866 30.862-7.866 0 0 17.794-1.697 27.734 17.998 0 0 22.724-1.241 44.021 2.745 0 0-24.233-42.7-66.354-42.039 0 0-12.312-.661-28.693 7.57l-6.626 3.124c-4.821 2.277-6.721 3.408-6.721 3.408s-6.816 4.083-13.337 3.882c0-.001-8.524.671-17.618-9.081zm-24.12.765s-11.285 31.124 13.42 45.037c4.6 2.993 11.944 5.767 20.237 5.979 0 0 33.765-16.09 70.513-20.342 0 0-4.25-9.064-20.868-9.064 0 0-10.152-.598-28.565 4.496 0 0-4.988 1.264-10.84 3.266-8.364 2.049-22.315 4.11-31.32-1.578-.001-.001-12.262-6.081-12.577-27.794zm-31.729 52.385s3.058 16.616 22.137 16.616c0 0 13.35.318 32.18-11.172 0 0-6.5-2.528-9.8-4.672 0 0-6.922-5.236-14.264-3.196 0 0-1.266.244-7.976 3.092 0 0-4.708 3.056-11.418 3.056-.001.001-6.818-.105-10.859-3.724z"
        fill="#fb4f14"
      />
      <path
        d="m220.509 223.078s38.008-40.202 92.885-26.224c0 0 2.713 31.474 36.623 33.388 0 0 11.547.695 22.461-6.992l21.32 7.967-22.362-14.086s-7.162 6.988-20.099 6.988c-12.938 0-28.653-13.111-27.263-31.718 0 0-23.509-11.786-49.731-17.907l7.859 12.416s-50.945-3.234-92.711 29.176c0 0-39.852-8.834-44.651-16.517 0 0 82.042-66.688 187.052-39.638 0 0 1.228-1.801-1.824-4.315 0 0-3.94-2.952-9.789-4.706 0 0 25.687-1.372 39.089 18.108l29.526 12.414-3.101 2.185s45.14 28.066 48.16 31.991l6.297 2.632s-4.478 13.113 4.708 20.187l-3.408 9.023s-15.095-16.262-30.154-16.909c0 0-11.131-.262-11.131 8.667 0 0-1.332 9.538 20.837 12.296l-4.578 4.225-16.909-1.074s.39-13.761-29.116-24.504c0 0-24.218 14.404-47.16-3.365 0 0-41.807 10.044-45.581 48.53 0 0-4.595-14.544-14.817-26.953 0 0 5.505-19.627 35.266-29.488 0 0-26.718-1.37-45.492 19.993.001-.002-12.444-10.134-32.206-15.79z"
        fill="#fff"
      />
      <path
        d="m357.105 177.563s20.83 3.105 56.64 32.352l-33.851-18.49s-2.189 1.12-3.562 2.338c.001.001-7.655-8.848-19.227-16.2z"
        fill="#024"
      />
      <path
        d="m374.08 183.761s-1.742 1.44-1.038 3.954c0 0 .853 2.37 3.539 2.424 0 0 3.036.041 3.568-3.275l-1.438-.774-3.742 2.799 1.052-4.183z"
        fill="#fb4f14"
      />
      <path
        d="m434.243 219.146s-2.873 1.067-2.873 3.643c0 0-.693 2.681 5.083 8.455 0 0-8.583-6.277-10.19-10.057 0 0-1.48-2.772 2.7-2.772-.001 0 2.54 0 5.28.731zm-97.512-57.251s5.293.077 5.905-1.219c0 0 1.295-1.35-5.828-4.681 0 0 10.987 2.244 15.973 11.118 0 0-7.121-3.257-16.05-5.218z"
        fill="#024"
      />
    </svg>
  );
};

DEN.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

DEN.defaultProps = {
  size: '100'
};

export default DEN;
